import { Form } from 'antd';
import { Formik, FormikConfig, FormikProps } from 'formik';
import { css } from '@emotion/css';
import Name from './Name';
import StoreList from './StoreList';
import Enable from './Enable';
import { FV } from './share';
import { ReactNode } from 'react';

export interface TaskFormProps extends Util.PartialPartial<FormikConfig<FV>, 'initialValues'> {
  children: (form: ReactNode, props: FormikProps<FV>) => ReactNode;
}

const defaultInitialValues: FV = {
  name: '',
  storeList: [],
  enable: false,
};

function TaskForm(props: TaskFormProps) {
  const { children, initialValues = defaultInitialValues, ...otherProps } = props;

  return (
    <Formik enableReinitialize initialValues={initialValues} {...otherProps}>
      {(props) => {
        const form = (
          <Form
            className={css`
              .ant-form-item {
                margin-bottom: 16px !important;
                &:last-of-type {
                  margin-bottom: 0 !important;
                }
              }
            `}
          >
            <Name />
            <StoreList />
            <Enable />
          </Form>
        );

        return children(form, props);
      }}
    </Formik>
  );
}

export default TaskForm;
